import React from 'react';
import { Redirect } from "react-router-dom";
import { connect } from 'react-redux';
import Select from 'react-select';
import ui from 'redux-ui';
import { PageTitle } from '../PageTitle';
import { Message } from '../Message';
import Masonry from 'react-masonry-component';

import { GroupingsService } from '../../services';
import i18next from "i18next";

import config from "config";

@ui({
  key: 'monitoring-dashboard',
  persist: true,
  state: {
    selectedGroup: null,
    selectedGrouping: null,
    filterTimeframeValue: null
  }
})
@connect(state => {
  return {
    currentGrouping: state.currentGrouping.currentGrouping,
    me: state.user.me
  }
})
class OriginalDashboard extends React.Component {
  constructor(props) {
    super(props);

    var successMessage = null;

    if (localStorage.getItem('global_success_message')) {
      successMessage = localStorage.getItem('global_success_message');
    }

    this.state = {
        filterTimeframeValue: this.props.ui.filterTimeframeValue == null ? { value: 0, label: i18next.t('form-labels.last-twelve-hours') } : this.props.ui.filterTimeframeValue,
        lineData: [],
        lineKeys: [],
        skipInterval: 0,
        alertAreaPieData: [],
        alertAreaTotal: 0,
        awarenessPieData: [],
        awarenessTotal: 0,
        criticalPieData: [],
        criticalTotal: 0,
        actionBarData: [],
        filterGroupOptions: null,
        filterGroupValue: null,
        filterGroupingOptions: null,
        filterGroupingValue: null,
        hasError: false,
        animationDuration: 500,
        isAnimationActive: true,
        groupingFilterOptions: [],
        groupingFilterValue: null,
        curGrouping: this.props.ui.selectedGrouping ? this.props.ui.selectedGrouping : {id: this.props.currentGrouping.id, name: this.props.currentGrouping.name},
        localSuccessMessage: successMessage
    };
  }

  componentDidMount() {
    this.refresh();
  }

  componentWillUnmount() {
    clearInterval(this.refreshInterval);
  }

  updateFilterTimeframeValue(selectedValue) {
    this.props.updateUI('filterTimeframeValue', selectedValue);

    this.setState({
      filterTimeframeValue: selectedValue,
      loading: true
    }, () => {
      this.refreshSecondary();
    });
  }

  refresh() {
      GroupingsService.getDashboardData(this.state.curGrouping.id, this.state.filterTimeframeValue.value).then(response => {
        this.setState({groupings: response.data});
      }).catch(error => {
          console.error(error);
          this.state.localErrorHandler(error.message);
      })
      GroupingsService.getAllWithAccess(this.props.currentGrouping.id, true).then(response => {
        const groupingFilterOptions = response.groupings;
        this.setState({
          groupingFilterOptions: groupingFilterOptions,
          groupingFilterValue: {value: this.state.curGrouping.id, label: this.state.curGrouping.name}
        });
      }).catch(error => {
        console.error(error);
        this.state.localErrorHandler(error.message);
      });
  }

  refreshSecondary() {
    this.setState({loading: true})
      GroupingsService.getDashboardData(this.state.curGrouping.id, this.state.filterTimeframeValue.value).then(response => {
        this.setState({groupings: response.data, loading: false})
      }).catch(error => {
          console.error(error);
          this.state.localErrorHandler(error.message);
      })
  }

  length(arr){
    return Object.keys(arr).length
  }

  updateGroupingFilterValue(newValue) {
    let curGrouping = this.state.curGrouping
    if (newValue != null) {
      curGrouping.id = newValue.value
      curGrouping.name = newValue.label
    } else {
      curGrouping.id = this.props.currentGrouping.id
      curGrouping.name = this.props.currentGrouping.name
      newValue = {value: curGrouping.id, label: curGrouping.name}
    }
    this.props.updateUI('selectedGrouping', curGrouping);
    this.setState({
      groupingFilterValue: newValue,
      curGrouping: curGrouping,
      loading: true
    }, () => {
      this.refreshSecondary();
    });
  }

  renderMessages() {
    return this.state.localErrorMessage || this.state.localSuccessMessage
    ? (<Message  messages={{ state: { successMessage: this.state.localSuccessMessage } }} errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />)
    : (null)
  }

  messageDismissCallback() {
    localStorage.removeItem('global_success_message');
    this.setState({ localErrorMessage: null, localSuccessMessage: null });
  }

  render() {
      if ((!this.state.groupingFilterValue && !this.state.filterGroupingOptions) || !this.state.groupings || this.state.loading) {
      return (
        <div className="loader">{ i18next.t('loading') }</div>
      );
    }

    const renderLegend = (props) => {
      return (
        <div className="chart-legend chart-legend-round">
          <ul className="list-inline chart-legend-data">
          { props.payload.map((entry, index) => ( <li className={entry.value} key={`item-${index}`} style={{}}>{entry.value}</li> )) }
          </ul>
        </div>
      );
    }

    this.MASONRY_OPTIONS = {
      itemSelector: '.masonry-item',
      transitionDuration: 0,
      percentPosition: true,
      columnWidth: '.masonry-sizer',
      gutter: '.gutter-sizer',
      stagger: 30
    };

    return (
      <div className="animated fadeIn">
        <div className="row">
          {this.renderMessages()}
          <PageTitle
            title={ i18next.t('pages.dashboard.header') }
            refreshFunction={this.refreshSecondary.bind(this)}
          />
        </div>
      <div className="d-region">
        <div className="op-content-box monitoring-location-map">
          <div className="d-region__heading">
            <span className="time-select" style={{ zIndex: 900 }}>
            <span className="time-select-label">{ i18next.t('form-labels.timeframe') }</span>
              <Select
                options={[
                    { value: 0, label: i18next.t('form-labels.last-twelve-hours') },
                    { value: 1, label: i18next.t('form-labels.last-twenty-four-hours') },
                    { value: 2, label: i18next.t('form-labels.last-week') },
                    { value: 3, label: i18next.t('form-labels.last-month') },
                    { value: 4, label: i18next.t('form-labels.last-year') }
                  ]}
                clearable={false}
                value={this.state.filterTimeframeValue}
                onChange={this.updateFilterTimeframeValue.bind(this)}
                searchable={false}
                classNamePrefix="react-select"
                placeholder={i18next.t('select')}
                />
            </span>
            <span className="region-select" style={{ zIndex: 910 }}>
              <span className="time-select-label">{ i18next.t('form-labels.region') }</span>
              <Select
                  placeholder={i18next.t('select')}
                  ref="filterByGroupingSelect"
                  options={this.state.groupingFilterOptions}
                  name="selected-filter-by"
                  value={this.state.groupingFilterValue}
                  onChange={this.updateGroupingFilterValue.bind(this)}
                  isSearchable={true}
                  classNamePrefix="react-select"
                  isFocused={true}
              />
            </span>
          </div>

          <Masonry options={this.MASONRY_OPTIONS}>
            <div className="masonry-sizer" />
            <div className="gutter-sizer" />
            {this.state.groupings.map((store, index) => (
              <div className="masonry-item" key={index}>
                <GroupingCard setFilter = {this.updateGroupingFilterValue.bind(this)} parentGrouping = {this.state.curGrouping} store = {store} />
              </div>
            ))}
          </Masonry>
        </div>
      </div>
      </div>
    );
  }
}

class GroupingCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      linkToLeaf: false
    };
  }

  viewClicked() {
    if (this.props.store.grouping.deviceGroup.children.length === 0) {
      this.setState({ linkToLeaf: true })
    } else {
      this.props.setFilter({ label: this.props.store.grouping.name, value: this.props.store.grouping.id })
    }
  }

  render() {
    const { index } = this.props;
    const { grouping } = this.props.store;

    if (this.state.linkToLeaf) {
      return <Redirect push to={{ pathname: `/monitoring/locations/${this.props.store.grouping.id}/devices`}} />;
    }

    return (
      <div className=" dash-card-region" key={index}>
        {/* TOP SECTION */}
        <div className="card__dash__top">
          <div className="row">
            <div className="card__dash__content col-xs-2">
              <img src={`${config.WEB_BASE_URL}/images/icon/location-white.svg`} alt={i18next.t('pages.dashboard.map-marker-icon')} />
            </div>
            <div className="card__dash__content col-xs-7">
              <p>{grouping.name}</p>
              <p> {this.props.parentGrouping.name} </p>
            </div>
            <div className="card__dash__content col-xs-3">
              <button onClick = {this.viewClicked.bind(this)} className="btn btn-default btn-sm dash-btn__view"> { i18next.t('form-labels.view') } </button>
            </div>
          </div>
        </div>

        {/* MIDDLE SECTION */}
        <div className="card__dash__mid">
          <ul className="list-inline dash-alerts">
            <li> <span className="alert-highlight red"> {this.props.store.criticalCount} </span> <span className="alert-type"> { i18next.t('pages.dashboard.critical') } </span> </li>
            <li> <span className="alert-highlight yellow"> {this.props.store.warningCount} </span> <span className="alert-type"> { i18next.t('pages.dashboard.warning') } </span> </li>
            <li> <span className="alert-highlight green"> {this.props.store.informationalCount} </span> <span className="alert-type"> { i18next.t('pages.dashboard.informational') } </span> </li>
          </ul>
        </div>

        {/* BOTTOM SECTION */}
        <div className="card__dash__bottom">
          <div className="list-inline">
            { i18next.t('pages.dashboard.tickets') }
          </div>
          <ul className="list-inline dash-tickets">
            <li> <span>{this.props.store.unassignedCount}</span> <br /> { i18next.t('pages.dashboard.unassigned') } </li>
            <li> <span>{this.props.store.assignedCount}</span> <br /> { i18next.t('pages.dashboard.assigned') } </li>
            <li> <span>{this.props.store.resolvedCount}</span> <br /> { i18next.t('pages.dashboard.resolved') } </li>
          </ul>
        </div>
      </div>
    )
  }
}


export default OriginalDashboard;
